/**
 * ModuleGrid.tsx — modulkort (like høye, klikkbare)
 *
 * Følger ibm.com sine produktkort: tittel øverst, ikon nede til venstre og
 * pil nede til høyre, separate kort med 16px mellomrom. Seksjonshodet er
 * todelt (stor lettvekts-tittel + tekst), som «Top enterprise technology».
 * 1 kolonne (sm), 2 (md), 3 (lg). Statusetikett (f.eks. Alpha) som Carbon-tag.
 */

import { ArrowRight } from '@carbon/icons-react';
import type { LandingContent } from '@/types/landing';
import { LANDING_ICONS } from './landing-icons';
import styles from './landing-sections.module.css';

export default function ModuleGrid({ modules }: { modules: LandingContent['modules'] }) {
  return (
    <section id="moduler" className={styles.sectionAlt} aria-labelledby="modules-heading">
      <div className={styles.container}>
        <div className={styles.statement}>
          <h2 id="modules-heading" className={styles.h2}>
            {modules.heading}
          </h2>
          <p className={styles.lead}>{modules.intro}</p>
        </div>

        <ul className={styles.tiles} role="list">
          {modules.items.map((item) => {
            const Icon = LANDING_ICONS[item.icon];
            return (
              <li key={item.id} className={styles.tileItem}>
                <a href={item.href} className={styles.tile}>
                  <span className={styles.tileHead}>
                    <span className={styles.tileName}>{item.name}</span>
                    {item.status && <span className={styles.tag}>{item.status}</span>}
                  </span>
                  <span className={styles.tileText}>{item.description}</span>
                  <span className={styles.tileFoot}>
                    <Icon className={styles.pictogram} aria-hidden />
                    <ArrowRight size={20} aria-hidden className={styles.tileArrow} />
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
